import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Icons } from "assets/icons";
import { Images } from "assets/images";

const AdminSidebar = () => {
  const location = useLocation();

  const { dashboard, dashboard2 } = Icons || {};
  const { logo } = Images || {};

  const sidebarItems = [
    {
      label: "Overview",
      path: "/dashboards/overview",
      activePaths: ["/dashboards/overview"],
      icon: dashboard,
      iconHover: dashboard2,
    },
    {
      label: "Bookings",
      path: "/bookings",
      activePaths: ["/bookings", "/bookings/:id"],
      icon: dashboard,
      iconHover: dashboard2,
    },
    {
      label: "Users",
      path: "/users",
      activePaths: ["/users"],
      icon: dashboard,
      iconHover: dashboard2,
    },
  ];

  // Active route checker
  const isActive = (paths = []) =>
    paths.some((p) => location.pathname.startsWith(p)) ? "active" : "";

  return (
    <div className="sidebar_menu">
      {/* Logo */}
      <div className="g_between">
        <Link to="/dashboards/overview" className="sidebar_logo">
          <img src={logo} alt="Logo" width={100} height={55} />
        </Link>
      </div>

      {/* Menu */}
      <nav id="sidebar-menu">
        <ul className="p-0">
          {sidebarItems.map((item, index) => (
            <li
              key={index}
              className={item.label === "Overview" ? "overview_li" : ""}
            >
              <Link to={item.path} className={isActive(item.activePaths)}>
                {/* Default Icon */}
                <img
                  src={item.icon}
                  className="main_icon"
                  alt={item.label}
                  width={20}
                  height={20}
                />

                {/* Hover Icon */}
                <img
                  src={item.iconHover}
                  className="hover_icon"
                  alt={`${item.label} hover icon`}
                  width={20}
                  height={20}
                />

                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default AdminSidebar;
